export default {
  pageTitle: 'Warehouse Execution Monitor',
  allRobots: 'All Robots',
  smtRobotName: 'Industrial SMT Loading Robot',
  mockRobotIdleName: 'AVG1',
  mockRobotChargingName: 'AVG2',
  taskQueue: 'Task Queue',
  robotStatus: 'Robot Status',
  currentTaskDetail: 'Current Task',
  tabAll: 'All',
  tabPending: 'Pending',
  tabRunning: 'Running',
  tabCompleted: 'Done',
  tabError: 'Error',
  sourceLocation: 'From',
  targetLocation: 'To',
  targetPosition: 'Destination',
  defaultTarget: 'SMT Line Area A',
  executeRobot: 'Robot',
  eta: 'ETA',
  etaSeconds: '{n}s',
  etaMinutes: '{n} min',
  etaMinutesSeconds: '{m}m {s}s',
  taskId: 'Task ID',
  material: 'Material',
  taskProgress: 'Progress',
  unitOrder: '',
  unitRobot: '',
  unitAlert: '',
  statTotalToday: 'Tasks Today',
  statCompleted: 'Completed',
  statCompletionRate: 'Completion Rate',
  statRunningRobots: 'Active Robots',
  statAlerts: 'Alerts',
  statPending: 'Pending Tasks',
  statusPending: 'Pending',
  statusRunning: 'Running',
  statusCompleted: 'Done',
  statusError: 'Error',
  robotRunning: 'Running',
  robotIdle: 'Idle',
  robotPicking: 'Picking',
  robotCharging: 'Charging',
  emptyTask: 'No tasks',
  emptyRobot: 'No robots',
  emptyDetail: 'Select a task to view details',
  shipmentOrderTitle: 'Shipment Orders',
  colOrderNo: 'Shipment Order No.',
  colOrderType: 'Order Type',
  colProductTypes: 'Product Types',
  colOrderStatus: 'Shipment Status',
  colOwner: 'Owner',
  colWarehouseNo: 'Warehouse No.',
  colConsignee: 'Consignee',
  orderTypeProduction: 'Production Picking',
  productTypeRaw: 'Raw Materials',
}
